export default __webpack_public_path__ + "static/media/avatar.fed8a1cf.png";